var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30.75C35.5229 25.2272 35.5229 16.2728 30 10.75C24.4772 5.22715 15.5228 5.22715 10 10.75C4.47715 16.2728 4.47715 25.2272 10 30.75C15.5228 36.2728 24.4772 36.2728 30 30.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1918 15.7793C16.1918 16.5415 15.6107 17.1587 14.7037 17.1587C13.7966 17.1587 13.2519 16.5415 13.27 15.7793C13.2519 14.981 13.8329 14.3818 14.7218 14.3818C15.6107 14.3818 16.1736 14.981 16.1918 15.7793ZM13.3438 27.1195V18.2469H16.1012V27.1195H13.3438Z",
    fill: "#020802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3166 21.0784C18.3166 19.9721 18.2804 19.0288 18.2441 18.2486H20.6393L20.766 19.4649H20.8204C21.1826 18.902 22.0911 18.0493 23.5596 18.0493C25.3737 18.0493 26.735 19.2462 26.735 21.86V27.1212H23.9776V22.2042C23.9776 21.0617 23.5777 20.2814 22.5801 20.2814C21.818 20.2814 21.3652 20.8081 21.1826 21.3152C21.1102 21.4783 21.074 21.7514 21.074 22.0049V27.1212H18.3166V21.0798V21.0784Z",
    fill: "#020802"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bad7a44fda2c46e4a7befe1dd7a8c195.svg";
export { ForwardRef as ReactComponent };